module.exports = __webpack_public_path__ + "img/icon-scan-smartphone@3x.1bc83fd2.png";